import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
export default function* watcherGetSuppliersSaga() {
  yield takeEvery("LOAD_SUPPLIERS", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};

    var formatUrl = `/get-suppliers`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "SUPPLIERS_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("Suppliers-List", e);
    console.log("Suppliers-List-Error", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
